{
  "numbers3": [
    {
      "number": "49%",
      "text": "pracowników umysłowych postrzega narzędzia cyfrowe zapewnione przez swoją organizację jako frustrujące."
    },
    {
      "number": "65%",
      "text": "z nich wierzy, że byliby bardziej produktywni, gdyby mieli dostęp do lepszej technologii."
    },
    {
      "number": "25%",
      "text": "podaje brak odpowiedniej technologii jako powód zmiany pracy."
    }
  ],
  "numbers4": [
    {
      "number": "01.",
      "title": "Dostosuj ofertę",
      "text": "Dostosuj ofertę do potrzeb Twojej firmy – wybierz interesujące moduły"
    },
    {
      "number": "02.",
      "title": "Uruchom platformę",
      "text": "Uruchom platformę MyBenefit w swojej firmie – skorzystaj z pełnego wsparcia"
    },
    {
      "number": "03.",
      "title": "Mierz efekty",
      "text": "Mierz efekty - oszczędzaj czas, nagradzaj, motywuj"
    }
  ]
}
